import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-google-reviews',
  templateUrl: './google-reviews.component.html',
  styleUrl: './google-reviews.component.scss'
})
export class GoogleReviewsComponent {
  reviews = [
    {
      name: 'Somu Raj',
      image: 'https://lh3.googleusercontent.com/a/ACg8ocIuHFMoR1eAN40avGUuzFCgItDwGcjZh5uYQKFJOOjcd8d_HA=s1920-c-rp-mo-br100',
      rating: 5,
      text: '',
      dateAgo: '4 days ago',
      reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT21aWVZrRlNkakJaTjNkbFFUQmlaV0pKZG5OME0xRRAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CAIQACodChtycF9oOmZYVkFSdjBZN3dlQTBiZWJJdnN0M1E%7C0cMsIo1lWBy%7C?hl=en'
    },
    {
      name: 'Frank NM',
      image: 'https://lh3.googleusercontent.com/a-/ALV-UjVNNJV8A5mQzTEPG1CGuk7eKaMGFVXUWkzISgplsLwtSDVhWdcRtg=s1920-c-rp-mo-ba4-br100',
      rating: 5,
      text: `Hi folks I am writing this review out of my complete satisfaction with the company or store I bought my entire house tiles ,the name is " The Tile Store ". The first thing I thought of  when I started my house construction was tiles . I always loved and preferred big size tiles than small ones . Whiles looking for tiles in multiple outlets I couldn't figure the ones we need , accidentally we entered this showroom . Once you entered this showroom "THE TILE STORE "(exclusive for KAJARIA), you will be greeted by the crew working there specifically Meera Balachandar Manager of the store , a hard and smart working employee will make sure your time there is one hundred percent worth . It's a very big showroom with all  tiles you would ever ask for . At last I got my 8*4 size tiles and preferably every tiles tiles from there including kitchen , bathroom, bedroom , hall , steps and parking . We couldn't make the choice that easy as every tiles were attractive and the shades no words . The travel was not one time as I had to go there multiple times and do selection ,during all my visits Manager Meera was so accommodating and helpful walking with us for hours with only smile in her face . Price vise I felt comfortable but could be better and some might feel priced high , we got what we want so I was k with the price . I would recommend this place  without any doubt you will get what you have in your-mind for your house ,if you give some time and patience. For the store pls keep up this good work to each and everyone , I am sure things will work out for both parties . Thanks`,
      dateAgo: 'a week ago',
      reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT20xc1JtcDZXamhUYlVSbGVubGZibXh3WmpOd01tYxAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CAIQACodChtycF9oOm1sRmp6WjhTbURlenlfbmxwZjNwMmc%7C0cLufjDCfZd%7C?hl=en'
    },
    {
      name: 'Box Black Internationals',
      image: 'https://lh3.googleusercontent.com/a/ACg8ocLPa5ujQkmZ39yGwSK2ROH1YHPc-wpn3gCVk3sC8L38oUJYPA=s1920-c-rp-mo-br100',
      rating: 5,
      text: 'Wide variety of tiles ranges and pricing. Good Pricing… Friendly team.',
      dateAgo: '2 weeks ago',
      reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT25acVZrZzBkRkJLU0doMlgwTkZiMW80WlhKQkxYYxAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CAIQACodChtycF9oOnZqVkg0dFBKSGh2X0NFb1o4ZXJBLXc%7C0cJEXc3w82s%7C?hl=en'
    },
    {
      name: 'Ram kumar',
      image: 'https://lh3.googleusercontent.com/a-/ALV-UjWV1C9mM06b8HnxI6XiQ_sg8kYEfpFj4GZB6hJiPvB78dkt2pk=s1920-c-rp-mo-br100',
      rating: 5,
      text: 'Unique collection....best experience.... wonderful response from the staffs. Especially Mrs. Meera your doing great job',
      dateAgo: '2 weeks ago',
      reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VMS0ZyWmVzdWRMajBnRRAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CIHM0ogKELKFrZesudLj0gE%7CCgwIupC-wgYQ8OK1pQM%7C?hl=en'
    },
    {
      name: 'Sharad Jalan',
      image: 'https://lh3.googleusercontent.com/a/ACg8ocLqLLiMOaILaaAmba9HKRh14VzSCDWG9x7-b18Ag0rmKOSwhg=s1920-c-rp-mo-br100',
      rating: 5,
      text: '',
      dateAgo: '2 weeks ago',
      reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT214UVIxQTBUMjVKWW1GTmJuTlZRVTl2YjBNMmVFRRAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CAIQACodChtycF9oOmxQR1A0T25JYmFNbnNVQU9vb0M2eEE%7C0cIl30RZDeC%7C?hl=en'
    },
    {
      name: 'Hunter gaming',
      image: 'https://lh3.googleusercontent.com/a/ACg8ocJOeR3j40WvwJTMy3Tv9BGQzhCFLUVV-DL67hojosBBdASSow=s1920-c-rp-mo-br100',
      rating: 5,
      text: 'wonderful ambience, latest collections, fully satisfied .',
      dateAgo: '2 weeks ago',
      reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VQaUczWVhDelBMZnJRRRAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CIHM0ogKEPiG3YXCzPLfrQE%7CCgwIoJC8wgYQsNyBvgM%7C?hl=en'
    },
    {
      name: 'Saurabh Agarwal',
      image: 'https://lh3.googleusercontent.com/a/ACg8ocI6hDWD7J27VW_rE1TNZ_wEESWfD8QCw2Cc7AKAUHcbxw-CTF7j=s1920-c-rp-mo-br100',
      rating: 5,
      text: '',
      dateAgo: '2 weeks ago',
      reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2xsNFZrOTJVSFpUWjFSUFNIUlRlVGM1YVdoVGNrRRAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CAIQACodChtycF9oOll4Vk92UHZTZ1RPSHRTeTc5aWhTckE%7C0cIkTmE_5LU%7C?hl=en'
    },
    {
      name: 'prabhakaran ganesan',
      image: 'https://lh3.googleusercontent.com/a-/ALV-UjUxuutDLHwVAwVhCdc1wvnxgZxp_OmaaKqkH7mu4wHStVaQJJYr8Q=s1920-c-rp-mo-br100',
      rating: 5,
      text: '',
      dateAgo: '2 weeks ago',
      reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VOcmpvYUdMeEtMbW53RRAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CIHM0ogKENrjoaGLxKLmnwE%7CCgsI0Oe7wgYQiPfmYA%7C?hl=en'
    },
    {
      name: 'akash kumar',
      image: 'https://lh3.googleusercontent.com/a-/ALV-UjWN3AkbTB664dBVl3rgfYRLazu97I4QtAnx9Sd0gQxtqAb9CiWC=s1920-c-rp-mo-br100',
      rating: 5,
      text: 'Awesome store and all latest stock',
      dateAgo: '2 weeks ago',
      reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT25KQ05WZDZOekl4UzJaZlFYTkpTRTlRV2sxTVJYYxAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CAIQACodChtycF9oOnJCNVd6NzIxS2ZfQXNJSE9QWk1MRXc%7C0cIioT-cco8%7C?hl=en'
    },
    {
      name: 'Radhe Goyal',
      image: 'https://lh3.googleusercontent.com/a/ACg8ocLi5SFWMj-WzFfDfu22eRh_4D3rDnRK-wzpP9KlznJLaoGpwQ=s1920-c-rp-mo-br100',
      rating: 5,
      text: '',
      dateAgo: '2 weeks ago',
      reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChZDSUhNMG9nS0VQU0NxX0hOb091ZEhnEAE!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CIHM0ogKEPSCq_HNoOudHg%7CCgsIkb27wgYQoPSxAg%7C?hl=en'
    },
	{
      name:"Lakshmi Priya",
      image:'https://lh3.googleusercontent.com/p/AF1QipPB5QoQeyFQUVHsXjcKbp84Yeufc8km3NPCqXcV=w408-h306-k-no',
      rating:5,
      text:'One of the best tiles showroom in chennai . I bought Kajaria tiles with very exclusive designs and affordable price .',
      dateAgo:'6 days ago',
      reviewUrl:"https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2xOc1FrRm1iM2xvTnpsc1psRjJlV2huYVRKdk1GRRAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CAIQACodChtycF9oOlNsQkFmb3loNzlsZlF2eWhnaTJvMFE%7C0cSDuijPzPn%7C?hl=en"
    },
    {
     name:"monish raj",
      image:'https://lh3.googleusercontent.com/a- ALV-UjXAMHb_oq-9GQd_-cYvs8tCDqvLAD3JfDdYvHXLpnxvKop_yXg=s1920-c-rp-mo-ba2-br100',
      rating:5,
      text:"If you're looking for the best tile store in Chennai, this is the place to go. They have a huge collection, covering every style and need — all under one roof. What really stands out is their hospitality. Owners Smitha and Anand personally take the time to guide you, explain the options, and help you choose what’s right. You won’t get this kind of care or variety in most other places — trust me, I’ve checked almost every store in the city. I own multiple restaurants and houses, and finding the right tiles was always a hassle until I came here. This review isn’t paid or fake — it’s just appreciation for the best tile shopping experience I’ve had. Highly recommended",
      dateAgo:'a week ago',
      reviewUrl:"https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2t4blVteFpjWEpKVldWV1VVcE5TMDFITFUxM2JtYxAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CAIQACodChtycF9oOkxnUmxZcXJJVWVWUUpNS01HLU13bmc%7C0cQvnhTPqvf%7C?hl=en"
    }
  ];

  visibleCount = 3;
  startIndex = 0;

  expandedReview: any = null;
  modalOpen = false;
  selectedReview: any = null;

  sectionTitle = [
    {
      title: 'What they say about us',
      paragraph: 'Real Google reviews from our clients.'
    }
  ];

  get visibleReviews() {
    return this.reviews.slice(this.startIndex, this.startIndex + this.visibleCount);
  }

  prevReview() {
    if (this.startIndex > 0) {
      this.startIndex--;
    }
  }

  nextReview() {
    if (this.startIndex < this.reviews.length - this.visibleCount) {
      this.startIndex++;
    }
  }

  expandReview(review: any) {
    this.expandedReview = review;
  }

  collapseReview() {
    this.expandedReview = null;
  }

  openModal(review: any) {
    this.selectedReview = review;
    this.modalOpen = true;
  }

  closeModal() {
    this.modalOpen = false;
    this.selectedReview = null;
  }
}
